export const adevertise=[
  {
    "displayText": "PUDHARI ADVERTISEMENT",
    "filename": "./assets/documentation/adv/PUDHARI ADVERTISEMENT.pdf",
    "link": ""
  },
  {
    "displayText": "PUNYANAGARI ADVERTISEMENT",
    "filename": "./assets/documentation/adv/PUNYANAGARI ADVERTISEMENT.pdf",
    "link": ""
  },
  {
    "displayText": "SCHEDULE ACAP",
    "filename": "./assets/documentation/adv/SCHEDULE ACAP.pdf",
    "link": ""
  },
  {
    "displayText": "SCHEDULE IL",
    "filename": "./assets/documentation/adv/SCHEDULE IL.pdf",
    "link": ""
  }
]